import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import {
    Toast
} from 'vant';

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'Home',
    component: Home

},
    {
        path: '/food/menu',
        name: 'menu',
        component: () => import('../views/food/Menu.vue'),
    },
    {
        path: '/order',
        name: 'Order',
        component: () => import('../views/Order.vue'),
    },
    {
        path: '/my/index',
        name: 'my',
        component: () => import('../views/my/Index.vue'),
    },
    {
        path: '/my/relation',
        name: 'Relation',
        component: () => import('../views/my/relation.vue'),
    },
    {
        path: '/index/scan',
        name: 'scanCodePage',
        component: () => import('../views/index/scan.vue')
    },
    {
        path: '/food/details',
        name: 'foodDetails',
        component: () => import('../views/food/goodsDetails.vue')
    },
    {
        path: '/food/deliveryManage',
        name: 'deliveryManage',
        component: () => import('../views/food/deliveryManage.vue')
    },
    {
        path: '/food/deposit',
        name: 'deposit',
        component: () => import('../views/food/deposit.vue')
    },
    {
        path: '/my/balance',
        name: 'balance',
        component: () => import('../views/my/balance.vue')
    },
    {
        path: '/my/withdraw',
        name: 'withdraw',
        component: () => import('../views/my/withdraw.vue')
    },
    {
        path: '/my/orderRecord',
        name: 'orderRecord',
        component: () => import('../views/my/orderRecord.vue')
    },
    {
        path: '/my/orderDetail',
        name: 'orderDetail',
        component: () => import('../views/my/orderDetail.vue')
    },
    {
        path: '/my/orderRefund',
        name: 'orderRefund',
        component: () => import('../views/my/orderRefund.vue')
    },
    {
        path: '/my/personal',
        name: 'personal',
        component: () => import('../views/my/personal.vue')
    },
    {
        path: '/my/bindPhoneStep1',
        name: 'bindPhoneStep1',
        component: () => import('../views/my/bindPhoneStep1.vue')
    },
    {
        path: '/my/bindPhoneStep2',
        name: 'bindPhoneStep2',
        component: () => import('../views/my/bindPhoneStep2.vue')
    },
    {
        path: '/my/bindStaffNo',
        name: 'bindStaffNo',
        component: () => import('../views/my/bindStaffNo.vue')
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/Login.vue')
    },
    {
        path: '/register',
        name: 'register',
        component: () => import('../views/Register.vue')
    },
    {
        path: '/empower',
        name: 'empower',
        component: () => import('../views/my/Empower.vue')
    },
    {
        path: '/authorization',
        name: 'authorization',
        component: () => import('../views/my/Authorization.vue')
    },
    {
        path: '/loading',
        name: 'loading',
        component: () => import('../views/index/Loading.vue')
    },
    {
        path: '/food/signIn',
        name: 'signIn',
        component: () => import('../views/food/SignIn.vue')
    },
    {
        path: '/userAgreeOn',
        name: 'userAgreeOn',
        component: () => import('../views/userAgreeOn.vue')
    },
    {
        path: '/userConceal',
        name: 'userConceal',
        component: () => import('../views/userConceal.vue')
    },
    {
        path: '/serviceTerms',
        name: 'serviceTerms',
        component: () => import('../views/serviceTerms.vue')
    },
    {
        path: '/index/qrcode',
        name: 'address',
        component: () => import('../views/index/Address.vue')
    },
    {
        path: '/index/editQrCode',
        name: 'editQrCode',
        component: () => import('../views/index/editQrCode.vue')
    },
    {
        path: '/index/chooseAddress',
        name: 'chooseAddress',
        component: () => import('../views/index/chooseAddress.vue')
    }
]

const router = new VueRouter({
    routes,
    mode: "history",
    // base: '/prod_lej/wap', //添加访问前缀路径
    base: '/wap', //添加访问前缀路径
    // 解决页面跳转保存滚动条位置问题
    scrollBehavior(to, from, savedPosition) {
        return {
            x: 0,
            y: 0
        }
    },
});
//免登录白名单
let whiteList = ['/', '/login', '/register', '/empower', '/loading', '/authorization', '/userAgreeOn', '/userConceal', '/serviceTerms', '/index/qrcode', '/index/editQrCode']

// 路由守卫
router.beforeEach((to, from, next) => {
    // to要跳转到的路径
    // from从哪个路径来
    // next往下执行的回调
    // 在localStorage中获取token
    let token = localStorage.getItem('user_token')
    //如果路由不在免登录白名单，先跳转登录，登录后跳回此路由
    if (whiteList.indexOf(to.path) === -1) {
        if (token) {
            next();
        } else {
            window.sessionStorage.setItem("skipAddress", encodeURIComponent(window.location.href));
            router.push('/login')
        }
    } else {
        next();
    }
});


// 路由守卫
router.afterEach((to, from) => {

})


export default router